<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-6 col-6 mb-1" v-if="is_allowed_create">
            <button
              :disabled="!showActionDelete"
              v-on:click="showConfirmationModal = true"
              class="btn btn-danger"
            >
              <i class="fa fa-trash"></i> Delete
            </button>
            <button
              v-on:click="onEditRow"
              :disabled="!showActionEdit"
              class="btn btn-primary">
              <i class="fa fa-edit"></i> Edit
            </button>
            <button v-on:click="onCreateNewResponse" class="btn btn-primary">
              Create Response
            </button>
          </div>
          <div class="col-6 pull-right">
            <div class="row">
              <label class="col-4 col-form-label form-control-label text-right">
                brand
              </label>
              <div class="col-8">
                <model-list-select
                  :list="brandCodeOption"
                  v-model="watch_brand_code"
                  option-value="value"
                  option-text="text"
                  placeholder="select brand code">
                </model-list-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message">
          <base-alert 
            :type="message.type" 
            :dismissible="true" 
            @resetMessage="resetMessage">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="deleteMessages[0].type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @refresh-data="onRefreshData"
        >
          <template slot="is_giid_only_column" slot-scope="props">
            <label v-if="props.cell_value == 0"> False </label>
            <label v-if="props.cell_value == 1"> True </label>
          </template>
        </vue-bootstrap4-table>
      </div>
    </div>
    <modal :show.sync="showConfirmationModal" modalClasses="modal-sm">
      <h3>Are you sure to delete these items?</h3>
      <ul>
        <li v-for="(row, index) in selectedItems" :key="index">
          {{ row.statement }}
        </li>
      </ul>
      <template slot="footer">
        <div class="row">
          <div class="col-lg-6">
            <base-button
              type="link"
              class="ml-auto btn-block"
              @click="showConfirmationModal = false"
              >No
            </base-button>
          </div>
          <div class="col-lg-6">
            <base-button
              type="primary"
              class="ml-auto btn-block"
              @click="onDeleteRow"
              >Yes
            </base-button>
          </div>
        </div>
      </template>
    </modal>
    <modal :show.sync="showModalCreate" modal-classes="modal-lg">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} User Task Response Config
      </h3>
      <form @submit.prevent>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <label class="form-control-label required">
                Brand Code
              </label>
              <model-list-select
                :list="brandCodeOption"
                v-model="watch_brand_code"
                option-value="value"
                option-text="text"
                placeholder="select item"
                :isDisabled="isBrandCodeDisabled"
              >
              </model-list-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <base-input
                alternative=""
                label="Response Media Url"
                input-classes="form-control"
                v-model="UserTaskResponseModel.response_media_url"
              />
            </div>
          </div>
          <div class="col-lg-6">
            <div id="preview-container">
              <div class="preview">
                <div class="preview" v-if="isImage(UserTaskResponseModel.response_media_url)">
                  <img :src="UserTaskResponseModel.response_media_url" class="img img-thumbnail" />
                </div>
                <div class="preview" v-else-if="isVideo(UserTaskResponseModel.response_media_url)">
                  <video controls class="img img-thumbnail">
                      <source :src="UserTaskResponseModel.response_media_url" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <label class="form-control-label required">
                Response Type
              </label>
              <model-list-select
                :list="allResponseType"
                v-model="watch_response_type"
                option-value="value"
                option-text="text"
                placeholder="select item"
              >
              </model-list-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <label class="form-control-label required">
                Response Format
              </label>
              <model-list-select
                :list="allResponseFormat"
                v-model="watch_response_format"
                option-value="value"
                option-text="text"
                placeholder="select item"
              >
              </model-list-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <base-input
              alternative=""
              label="Statement"
              required
              input-classes="form-control"
              v-model="UserTaskResponseModel.statement"
            />
          </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
            <base-input
              alternative=""
              label="Correct Answer"
              input-classes="form-control"
              v-model="UserTaskResponseModel.correct_answer"
            />
          </div>
        </div>   
        
        <div v-if="isResponseFreeOption">
          <label class="form-control-label">Response Option</label>
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-md-4">Value</div>
                <div class="col-md-4">Link Content</div>
                <div class="col-md-2"></div>
                <div class="col-md-2"></div>
              </div>
              
              <div v-for="(response, index) in UserTaskResponseModel.response" :key="index" class="row align-items-center my-3">
                <div class="col-md-4">
                  <input
                    type="text"
                    class="form-control"
                    v-model="response.value"
                    placeholder="Enter value"
                  />
                </div>
                <div class="col-md-4" style="height: 39px;">
                  <input
                    type="text"
                    class="form-control"
                    v-model="response.content_url"
                    placeholder="Enter value"
                  />
                </div>
                <div class="col-md-2">
                  <div class="preview-container">
                    <div class="preview" v-if="isImage(response.content_url)">
                      <button 
                        class="btn btn-danger close-btn" 
                        v-if="index > 0"
                        @click="removeResponse(index)"
                      >
                        <i class="fa fa-times">x</i>
                      </button>
                      <img :src="response.content_url" class="img img-thumbnail" />
                    </div>
                    <div class="preview" v-else-if="isVideo(response.content_url)">
                      <button 
                        class="btn btn-danger close-btn" 
                        v-if="index > 0"
                        @click="removeResponse(index)"
                      >
                        <i class="fa fa-times">x</i>
                      </button>
                      <video controls class="img img-thumbnail">
                        <source :src="response.content_url" type="video/mp4" />
                      </video>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Button to add a new response -->
              <div class="add-response-container mt-3">
                <button @click="addResponse" class="btn btn-primary">
                  Add Response
                </button>
              </div>
            </div>
          </div>
        </div>

        <br>
        </form>
        <template slot="footer">
          <base-button
            type="link"
            class="ml-auto"
            @click="removeFile()"
            >Close/ Cancel
          </base-button>
          <button
          v-on:click="createUpdateResponse"
          class="btn btn-primary"
          v-bind:disabled="disableButtonSubmit"
        >
          Submit
        </button>
        </template>
      </modal>
    </div>
</template>

<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import api_loyalty from "../api/api";
import "@/assets/vendor/multiselect/vue-multiselect.min.css";
import "vue2-datepicker/index.css";

export default {
  name: "ResponseList",
  data() {
    return {
      files:[],
      is_loads3presigned:false,
      is_allowed_create: false,
      watch_brand_code: "PHFortune",
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      showActionEdit: false,
      showActionDelete: false,
      brandCodeOption: [],
      isDisabledUpdate: false,
      titlePopup: "Create",
      message: null,
      UserTaskResponseModel: {
        id:"",
        brand_code: "PHFortune",
        response_media_url: "",
        response_type: "",
        response_format: "",
        statement:"",
        response: [{ 
          value: '', 
          content_url: '', 
        }],
        correct_answer: "",
      },
      uploadModel: [],
      showModalCreate: false,
      rows: [],
      allResponses: null,
      allResponseType: [
        { text: "Trivia/Quiz", value: "2" },
        { text: "Survey", value: "3" },
        { text: "Feed", value: "6" },
      ],
      allResponseFormat: [
        { text: "Slider", value: "1" },
        { text: "Choice", value: "2" },
        { text: "Free Option", value: "3" },
      ],
      isResponseFreeOption: true,
      watch_response_type: "",
      watch_response_format: "",
      columns: [
        {
          label: "ID",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "Brand",
          name: "brand_code",
          sort: true,
        },
        {
          label: "Response Type",
          name: "response_type_name",
          sort: true,
        },
        {
          label: "Response Format",
          name: "response_format_name",
          sort: true,
        },
        {
          label: "Statement",
          name: "statement",
          sort: true,
        },
        {
          label: "Correct Answer",
          name: "correct_answer",
          sort: true,
        },   
                           
      ],
      config: {
        pagination: true,
        pagination_info: true,
        num_of_visibile_pagination_buttons: 7,
        per_page: 10,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
        selected_rows_info: true,
        per_page_options: [5, 10, 20, 30],
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function(row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.is_allowed_create =
      this.$store.getters.isCheAdmin ||
      this.$store.getters.isFortuneAdmin ||
      this.$store.getters.isLoginUserAdmin;
    this.mappingRole();
    this.isBrandCodeDisabled = false;
    this.onRefreshData();
  },
  methods: {
    mappingRole() {
      let isCheAdmin = this.$store.getters.isCheAdmin;
      let isFortuneAdmin = this.$store.getters.isFortuneAdmin;
      let isCheReader = this.$store.getters.isCheReader;
      let isFortuneReader = this.$store.getters.isFortuneReader;
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isCheAdmin || isAdministrator || isCheReader) {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.watch_brand_code = this.UserTaskResponseModel.brandCode = "PHChe";
      }

      if (isFortuneAdmin || isAdministrator || isFortuneReader) {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.watch_brand_code = this.UserTaskResponseModel.brandCode = "PHFortune";
      }
    },
    ValidateForm() {
      if (
          this.UserTaskResponseModel.statement &&
          this.UserTaskResponseModel.response.length > 0 &&
          this.UserTaskResponseModel.correct_answer
      ) {
        return true;
      }
      return false;
    },
    resetMessage() {
      this.message = null;
      this.deleteMessages = [];
      this.selectedItems = [];
    },
    onResetForm() {
      this.UserTaskResponseModel = {...this.UserTaskResponseModel,
        id: null,
        brand_code: this.watch_brand_code,
        response_media_url: "",
        response_type: "",
        response_format: "",
        statement: "",
        response: [{
          value:'',
          content_url:'',
        }],
        correct_answer: "",
      };
      this.uploadModel = []
      this.showActionEdit = false
      this.watch_response_type = "";
      this.watch_response_format = "";
    },
    onCreateNewResponse() {
      this.showModalCreate = true;
      this.titlePopup = "Create";
      this.isBrandCodeDisabled = false;
      this.onResetForm();
    },
    toggleActive() {},
    async onRefreshData() {
      api_loyalty
        .GetAllUserTaskResponse(this.watch_brand_code)
        .then((data) =>
        {
          try
          {
            if(data.isSuccess){
              data.data.forEach(function (item){
                switch(item.response_type){
                  case "2": item.response_type_name = "Trivia/Quiz"; break;
                  case "3": item.response_type_name = "Survey"; break;
                  case "6": item.response_type_name = "Feed"; break;
                }

                switch(item.response_format){
                  case "1": item.response_format_name = "Slider"; break;
                  case "2": item.response_format_name = "Choice"; break;
                  case "3": item.response_format_name = "Free Option"; break;
                }
              }); 
              this.rows = data.data;
              this.allResponses = data.data;              
            }
          } catch (e)
          {
            console.log(e);
          }
        });
      
        this.UserTaskResponseModel = {...this.UserTaskResponseModel,
          statement: "",
          response: [{ value: '', content_url: '' }],
          correct_answer: "",
      };
      this.watch_response_type = "";
      this.watch_response_format = "";
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (payload.selected_items.length == 0) {
        this.showActionEdit = false;
        this.showActionDelete = false;
      }
      if (payload.selected_items.length > 1) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.UserTaskResponseModel = this.allResponses.filter(
        (x) => x.id === this.selectedItems[0].id
      )[0];

      if (typeof this.UserTaskResponseModel.response === 'string') {
        this.UserTaskResponseModel.response = JSON.parse(this.UserTaskResponseModel.response);
      }
      this.watch_response_type = this.UserTaskResponseModel.response_type;
      this.watch_response_format = this.UserTaskResponseModel.response_format;
      this.showModalCreate = true;
      this.isBrandCodeDisabled = true;
      this.titlePopup = "Update";
    },
    onDeleteRow() {
      this.selectedItems.forEach((element) => {
        let deleteRequest = {
          id: element.id,
        };
        this.UserTaskResponseModel.id = deleteRequest.id;

        api_loyalty
          .DeleteUserTaskResponse(this.UserTaskResponseModel.brand_code, this.UserTaskResponseModel)
          .then((response) => {
            var popupType = "success"
            if(response.isSuccess == false){
            popupType = "danger";
          }
            this.onRefreshData();
            let msg = {
              message:
              response.message + " : " + element.statement + "'.",
              type: popupType
            };
            this.deleteMessages.push(msg);
          })
          .catch((e) => {
            console.log(e);
            let msg = {
              message:
                "Failed to delete Response '" +
                element.statement +
                "'.",
              type: "danger",
            };
            this.deleteMessages.push(msg);
          });
      });
      this.showConfirmationModal = false;
    },

    async createUpdateResponse() {
      if (this.files.length > 0) {
        this.files.forEach((f) => {
          const exists = this.UserTaskResponseModel.response.some(
            (image) => image.content_url === f.url
          );
          if (!exists) {
            var data = {
              value: f.file,                 
              content_url: f.url,
            };
            this.UserTaskResponseModel.response.push(data);
          }
        });
      }

      if (this.UserTaskResponseModel.id) 
       {
        this.UserTaskResponseModel.brand_code = this.watch_brand_code;
        api_loyalty
        .UpdateUserTaskResponse(this.UserTaskResponseModel)
        .then((response) => {
          this.onRefreshData();
          var popupType = "success"
          if(response.isSuccess == false){
            popupType = "danger";
          }

          this.message = {
            message: response.message,
            type: popupType,
          };
        })
        .catch((e) => {
          console.log(e);
          this.message = {
            message: "Failed to Insert User Task Response.",
            type: "danger",
          };
        });
       }
       else
       {
        this.UserTaskResponseModel.brand_code = this.watch_brand_code;
        this.UserTaskResponseModel.id = "";

        api_loyalty.AddUserTaskResponse(this.UserTaskResponseModel)
        .then((response) => {
          this.onRefreshData();

            if(response.isSuccess){
              this.message = {
                message: "User Task Response created successfully.",
                type: "success",
              };
            }else{
              this.message = {
                message : "Failed to create User Task Response",
                type : 'danger'
              }
            }

        })
        .catch((e) => {
            console.log(e)
            this.message = {
              message : "Failed to create User Task Response",
              type : 'danger'
            }
        });
        }

        this.files.forEach(x => {
          api_loyalty.S3PutObject(
            x.presignedUrl,
            x.file
          );
        })

       this.onResetForm();
       this.showModalCreate = false;
    },
    addResponse() {
      if (!Array.isArray(this.UserTaskResponseModel.response)) {
        this.UserTaskResponseModel.response = [];
      }
      this.UserTaskResponseModel.response.push({ value: "", content_url: "" });
      this.uploadModel.push("");
    },
    removeResponse(index) {
      if (this.UserTaskResponseModel.response && this.UserTaskResponseModel.response.length > 0) {  
        this.UserTaskResponseModel.response.splice(index, 1);
        this.files.splice(index, 1);
        this.UserTaskResponseModel.response.value = '';
      }
    },
    removeFile() {
      this.showModalCreate = false;
    },
    isImage(url) {
      return url.match(/\.(jpeg|jpg|gif|png)$/i);
    },
    isVideo(url) {
      return url.match(/\.(mp4|webm|ogg)$/i);
    },
  },
  components: {
    VueBootstrap4Table,
    ModelListSelect,
  },
  watch: {
    watch_brand_code: function() {
      this.UserTaskResponseModel.brand_code = this.watch_brand_code;
      this.onRefreshData();
    },
    watch_response_type: function(val) {      
      this.UserTaskResponseModel.response_type= val;

      //if response type is feed
      if(val === "6") {
        this.allResponseFormat = [
          { text: "Choice", value: "2" }
        ];

        this.UserTaskResponseModel.response_format = "2";
        this.watch_response_format = "2";
      } else {
        this.allResponseFormat = [
          { text: "Slider", value: "1" },
          { text: "Choice", value: "2" },
          { text: "Free Option", value: "3" },
        ]
      }
    },
    watch_response_format: function(val) {
      this.UserTaskResponseModel.response_format = val;

      //if response format is free option
      if(val === "3") {
        this.isResponseFreeOption = false;
        this.UserTaskResponseModel.response = [{ 
          value: '', 
          content_url: '', 
        }];
      } else {
        this.isResponseFreeOption = true;
      }
    },
  },
  computed: {
    disableButtonSubmit: function () {
    let isDisabled = true;

    if(this.UserTaskResponseModel.brand_code &&
      this.UserTaskResponseModel.response_type &&
      this.UserTaskResponseModel.response_format &&
      this.UserTaskResponseModel.statement ){
      isDisabled = false;
    }
    return isDisabled;
    },
  }
};
</script>
<style scoped>
.mt-3 {
  margin-top: 15px;
  margin-bottom: 10px;
}
.add-response-container {
  text-align: left; 
}

.preview {
  display: inline-block;
  margin: 5px;
}

.preview img {
  max-width: 200px;
  max-height: 200px;
  display: block;
}

.required::after {
    content: " *";
    color: red;
    font-weight: bold;
}

.preview-container {
  position: relative;
  display: inline-block;
}

.close-btn {
  position: absolute;
  top: 13px;
  right: 5px;
  z-index: 10;
  padding: 2px 6px;
  border-radius: 50%;
  font-size: 14px;
}
</style>
